import { formatPrice } from "@/features/bookings/utils";
import { formatTimeInZone } from "@/lib/business-time";

export function formatClientName(client: { first_name: string; last_name: string }): string {
  return `${client.first_name} ${client.last_name}`.trim() || "Name not recorded";
}

export function formatCents(cents: number, currency: string | null): string {
  if (!currency) {
    return `${new Intl.NumberFormat("en", { maximumFractionDigits: 2 }).format(cents / 100)} (currency not recorded)`;
  }
  return formatPrice(cents, currency);
}

export function formatClientBookingDate(iso: string | null, timeZone: string | null): string {
  if (!iso) return "—";
  if (!timeZone) return "Time unavailable";
  const date = new Date(iso);
  return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", timeZone }).format(
    date,
  );
}

/** Month + year for mobile "Client since Feb 2024" subtitle. */
export function formatClientSince(iso: string): string {
  const date = new Date(iso);
  return new Intl.DateTimeFormat("en-US", { month: "short", year: "numeric" }).format(date);
}

function formatLongDate(iso: string, timeZone: string): string {
  const date = new Date(iso);
  return new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone,
  }).format(date);
}

/** Date + 24-hour time for booking history (no 12h clock). */
export function formatBookingDateTime(iso: string, timeZone: string | null): string {
  if (!timeZone) return "Time unavailable";
  return `${formatLongDate(iso, timeZone)} · ${formatTimeInZone(iso, timeZone)}`;
}
